// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sv35_Km7mKf_I5Kisft0 {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-top: 1.5em;
}

.Txm5OEOKizrLDQe0wG3T {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

/* on mobile full width spacer turns into 24px spacer and stretches right button 100% wide */


@media (max-width: 767px) {
  /* dont use spacer if there's no prev button */
  .Txm5OEOKizrLDQe0wG3T {
    flex: none;
    width: 0;
  }

  button + .Txm5OEOKizrLDQe0wG3T {
    flex: none;
    width: 24px;
  }
  .sv35_Km7mKf_I5Kisft0 button:last-child {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/haven-design/action-footer/action-footer.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,OAAO;AACT;;AAEA,4FAA4F;;;AAG5F;EACE,8CAA8C;EAC9C;IACE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,OAAO;EACT;AACF","sourcesContent":[".container {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  margin-top: 1.5em;\n}\n\n.spacer {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n/* on mobile full width spacer turns into 24px spacer and stretches right button 100% wide */\n\n\n@media (max-width: 767px) {\n  /* dont use spacer if there's no prev button */\n  .spacer {\n    flex: none;\n    width: 0;\n  }\n\n  button + .spacer {\n    flex: none;\n    width: 24px;\n  }\n  .container button:last-child {\n    -webkit-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sv35_Km7mKf_I5Kisft0`,
	"spacer": `Txm5OEOKizrLDQe0wG3T`
};
export default ___CSS_LOADER_EXPORT___;
